import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { useEffect } from "react";
import { ROUTE_PATHS } from "@/lib/index";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import CorporateCatering from "@/pages/CorporateCatering";
import WeddingsEvents from "@/pages/WeddingsEvents";
import CafeSupply from "@/pages/CafeSupply";
import BakeryDesserts from "@/pages/BakeryDesserts";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('lang', 'ar');
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <MotionConfig reducedMotion="user">
          <Toaster />
          <Sonner />
          <HashRouter>
            <Routes>
              <Route element={<Layout />}>
                <Route path={ROUTE_PATHS.HOME} element={<Home />} />
                <Route path={ROUTE_PATHS.CORPORATE_CATERING} element={<CorporateCatering />} />
                <Route path={ROUTE_PATHS.WEDDINGS_EVENTS} element={<WeddingsEvents />} />
                <Route path={ROUTE_PATHS.CAFE_SUPPLY} element={<CafeSupply />} />
                <Route path={ROUTE_PATHS.BAKERY_DESSERTS} element={<BakeryDesserts />} />
                <Route path={ROUTE_PATHS.ABOUT} element={<About />} />
                <Route path={ROUTE_PATHS.CONTACT} element={<Contact />} />
              </Route>
            </Routes>
          </HashRouter>
        </MotionConfig>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;